<template>
    <div class="bg-indigo-50 p-5 rounded" id="app-container">
        <div class="font-bold">Местоположение</div>
        <div class="mt-2">
            <yandex-map :settings="{apiKey: '818a0810-a765-4c89-afcf-a729a92addea'}" :coords="coords"
                        class="ymap-container" @mapWasInitialized="mapWasInitialized" zoom="10"
                        :controls="['zoomControl']"
            >
                <!--Markers-->
            </yandex-map>
        </div>
    </div>
</template>
<script>
import {yandexMap, loadYmap} from 'vue-yandex-maps'

export default {
    components: {yandexMap},

    props: {
        modelValue: {
            required: true
        }
    },

    data() {
        return {
            coords: [55.76, 37.64],
            circle: null,

            radius: 10000,
            circleCoords: [55.76, 37.60],
        }
    },

    mounted() {
        if (this.modelValue.lat && this.modelValue.lon) {
            this.circleCoords = [this.modelValue.lat, this.modelValue.lon]
            this.coords = [this.modelValue.lat, this.modelValue.lon]
        }

        if (this.modelValue.radius) {
            this.radius = this.modelValue.radius
        }

        this.$emit('update:modelValue', {
            radius: this.radius,
            lat: this.circleCoords[0],
            lon: this.circleCoords[1],
        })
    },

    methods: {
        setCircleData(radius, circle) {
            this.radius = radius
            this.circleCoords = circle
        },

        mapWasInitialized(myMap) {
            var myCircle = new ymaps.Circle([
                this.circleCoords,
                this.radius
            ], {}, {
                fillColor: "#DB709377",
                strokeColor: "#990066",
                strokeOpacity: 0.8,
                strokeWidth: 5
            });

            myMap.geoObjects.add(myCircle);
            myCircle.editor.startEditing();
            myCircle.events.add('click', function () {
                myCircle.editor.startEditing();
            })

            myCircle.events.add(['geometrychange', 'propertieschange'], () => {

                if (myCircle.geometry.getRadius() < 1000) {
                    myCircle.geometry.setRadius(1000)
                }

                this.setCircleData(myCircle.geometry.getRadius(), myCircle.geometry.getCoordinates())

                this.$emit('update:modelValue', {
                    radius: this.radius,
                    lat: this.circleCoords[0],
                    lon: this.circleCoords[1],
                })
            })

            this.circle = myCircle
        }
    },
}
</script>

<style>

.ymap-container {
    width: 100%;
    height: 500px;
}
</style>
